import * as ko from 'knockout';
import fetch from 'node-fetch';
import PageHeader from './components/PageHeader';
import PagePuff from './components/PagePuff';
import PageFooter from './components/PageFooter';
import FormsAttribute from './components/FormsAttribute';
import Auth from './components/Auth';
import MethodList from './components/MethodList';
import AuthLink from './components/AuthLink';
import User from './components/User';
import Application from './components/Application';
import { AuthViewModel } from './models';
import { LocalizationManager, LocalizationData } from './localization';
import { LogonmeConfiguration, LogonmeGlobalData, ViewId, FrontendConfiguration } from './configuration';

import ProgressBar from './components/ProgressBar';
import CookieConsent from './components/CookieConsent';
import FooterColumn from './components/FooterColumn';
import ContentHeader from './components/ContentHeader';
import ContentFooter from './components/ContentFooter';
import Anchor from './components/Anchor';

ko.components.register('page-header', PageHeader);
ko.components.register('page-puff', PagePuff);
ko.components.register('page-footer', PageFooter);
ko.components.register('page-footer-column', FooterColumn);
ko.components.register('forms-attribute', FormsAttribute);
ko.components.register('auth', Auth);
ko.components.register('method-list', MethodList);
ko.components.register('auth-link', AuthLink);
ko.components.register('user', User);
ko.components.register('application', Application);
ko.components.register('progress-bar', ProgressBar);
ko.components.register('cookie-consent', CookieConsent);
ko.components.register('content-header', ContentHeader);
ko.components.register('content-footer', ContentFooter);
ko.components.register('anchor', Anchor);

const config = new LogonmeConfiguration(window.location.href);
const [localizationData, frontendConfig] = await Promise.all([
  getLocalizationModel(config),
  getFrontendConfiguration(config)
]);
// localizationData.localizations logged after Logonme is initialized (if debug enabled)

const lm = new LocalizationManager(localizationData);
global.Logonme = new LogonmeGlobalData(lm, window.location.href, frontendConfig);

global.Logonme.log(localizationData.localizations);

global.Logonme.ViewConstructedCount.subscribe((count: number) => {
  global.Logonme.log(`Views ready ${count}`);
  if (count < 3) {
    return;
  }

  const lastLoginId = global.Logonme.LastLoginStore.getId();
  const startupMethod = global.Logonme.Configuration.startupMethod ?? lastLoginId;
  if (startupMethod) {
    global.Logonme.Configuration.startupMethod = startupMethod;
  }
  global.Logonme.SelectedMethod(null);
  global.Logonme.ActiveView(ViewId.Methods);
});

const pageTitle = lm.getText("page-title", "default");
document.title = pageTitle;

ko.applyBindings(new AuthViewModel(), document.getElementById('app'));

loadCssFile(`${config.baseUrl}/ls/${config.tenant}/asset/branding.css`);
loadCssFile(`${config.baseUrl}/ls/${config.tenant}/asset/branding-fonts.css`);

// Set tenant-specific favicon
const faviconLink = document.createElement('link');
faviconLink.rel = 'icon';
faviconLink.href = `${config.baseUrl}/ls/${config.tenant}/asset/favicon.ico`;
document.head.appendChild(faviconLink);

async function getLocalizationModel(cfg: LogonmeConfiguration): Promise<LocalizationData> {
  const uri = `${cfg.baseUrl}/ls/${cfg.tenant}/localization/i18n?version=${cfg.version}`;
  const response = await fetch(uri);
  const localizationModel = await response.json<LocalizationData>();
  return localizationModel;
}

async function getFrontendConfiguration(cfg: LogonmeConfiguration): Promise<FrontendConfiguration> {
  const uri = `${cfg.baseUrl}/ls/${cfg.tenant}/forms/configuration/frontend`;
  const response = await fetch(uri);
  return await response.json<FrontendConfiguration>();
}

function loadCssFile(filename: string): void {
  const file = document.createElement("link");
  file.setAttribute("rel", "stylesheet");
  file.setAttribute("type", "text/css");
  file.setAttribute("href", filename);
  document.getElementsByTagName("head")[0].appendChild(file);
}
